import * as types from './_actionTypes';

const initialState = {
  eligibleStudents: [],
  certificateRequests: [],
  loading: false,
  requesting: false,
  downloading: {},
  error: null
};

const collegeCertificatePublishingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ELIGIBLE_STUDENTS_REQUEST:
    case types.FETCH_CERTIFICATE_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_ELIGIBLE_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        eligibleStudents: action.payload,
        error: null
      };
    
    case types.FETCH_CERTIFICATE_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        certificateRequests: action.payload,
        error: null
      };
    
    case types.FETCH_ELIGIBLE_STUDENTS_FAILURE:
    case types.FETCH_CERTIFICATE_REQUESTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.REQUEST_CERTIFICATES_REQUEST:
      return {
        ...state,
        requesting: true,
        error: null
      };
    
    case types.REQUEST_CERTIFICATES_SUCCESS:
      return {
        ...state,
        requesting: false,
        certificateRequests: [action.payload, ...state.certificateRequests],
        error: null
      };
    
    case types.REQUEST_CERTIFICATES_FAILURE:
      return {
        ...state,
        requesting: false,
        error: action.payload
      };
    
    case types.DOWNLOAD_CERTIFICATES_REQUEST:
      return {
        ...state,
        downloading: {
          ...state.downloading,
          [action.payload]: true
        }
      };
    
    case types.DOWNLOAD_CERTIFICATES_SUCCESS:
      return {
        ...state,
        downloading: {
          ...state.downloading,
          [action.meta?.requestId]: false
        }
      };
    
    case types.DOWNLOAD_CERTIFICATES_FAILURE:
      return {
        ...state,
        downloading: {
          ...state.downloading,
          [action.meta?.requestId]: false
        },
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default collegeCertificatePublishingReducer;